const DASHBOARD_PATHS = new Set(["/dashboard"]);
export const DASHBOARD_SECONDARY_DELAY_MS = 750;

export const isDashboardPath = (pathname = window.location.pathname) =>
  DASHBOARD_PATHS.has(pathname) || /^\/[0-9a-f-]{20,}\/?$/i.test(pathname);

/**
 * Keep secondary shell traffic out of the dashboard's critical startup window.
 * The work is delayed, never discarded, and callers retain an explicit cancel.
 */
export function scheduleDashboardSecondaryWork(
  action: () => void,
  options?: { pathname?: string; delayMs?: number },
): () => void {
  if (!isDashboardPath(options?.pathname)) {
    action();
    return () => {};
  }
  const timer = window.setTimeout(
    action,
    options?.delayMs ?? DASHBOARD_SECONDARY_DELAY_MS,
  );
  return () => window.clearTimeout(timer);
}
